import { getApiErrorMessage } from './apiError';
export const AUTH_STORAGE_KEYS = {
  accessToken: 'access_token',
  tokenType: 'token_type',
};

export const AUTH_EXPIRED_EVENT = 'auth:expired';
export const AUTH_EXPIRED_CODE = -99;

export const getAccessToken = () => localStorage.getItem(AUTH_STORAGE_KEYS.accessToken) || '';

export const getTokenType = () => localStorage.getItem(AUTH_STORAGE_KEYS.tokenType) || 'bearer';

export const setAuthToken = (token, tokenType = 'bearer') => {
  localStorage.setItem(AUTH_STORAGE_KEYS.accessToken, token || '');
  localStorage.setItem(AUTH_STORAGE_KEYS.tokenType, tokenType || 'bearer');
};

export const clearAuthState = (axiosInstance) => {
  localStorage.removeItem(AUTH_STORAGE_KEYS.accessToken);
  localStorage.removeItem(AUTH_STORAGE_KEYS.tokenType);

  if (axiosInstance?.defaults?.headers?.common) {
    delete axiosInstance.defaults.headers.common.Authorization;
  }
};

const isUserApiUrl = (url = '') => url.includes('/v2/user/');
const isPublicUserApiUrl = (url = '') => url.includes('/v2/user/login') || url.includes('/v2/user/sms/send');
const isProtectedUserApiUrl = (url = '') => isUserApiUrl(url) && !isPublicUserApiUrl(url);

const makeAuthExpiredError = (source) => {
  const error = new Error('AUTH_EXPIRED');
  error.__authExpired = true;
  error.__silent = true;
  if (source) {
    error.source = source;
  }
  return error;
};

export const isAuthExpiredError = (error) => {
  if (!error) return false;
  if (error.__authExpired) return true;

  const status = error?.response?.status;
  const code = error?.response?.data?.code;
  return status === 401 || code === AUTH_EXPIRED_CODE;
};

export const appendUserAuthHeader = (config) => {
  const token = getAccessToken();
  const url = config?.url || '';

  if (token && isProtectedUserApiUrl(url)) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
};

export const setupAxiosAuthInterceptors = ({ axiosInstance }) => {
  const handleAuthExpired = () => {
    clearAuthState(axiosInstance);

    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT));
    }
  };

  axiosInstance.interceptors.request.use((config) => appendUserAuthHeader(config));

  axiosInstance.interceptors.response.use(
    (response) => {
      if (response?.data?.code === AUTH_EXPIRED_CODE) {
        handleAuthExpired();
        return Promise.reject(makeAuthExpiredError(response));
      }
      return response;
    },
    (error) => {
      const status = error?.response?.status;
      const code = error?.response?.data?.code;

      if (status === 401 || code === AUTH_EXPIRED_CODE) {
        handleAuthExpired();
        return Promise.reject(makeAuthExpiredError(error));
      }

      const friendlyMessage = getApiErrorMessage(error);
      if (friendlyMessage) {
        error.userMessage = friendlyMessage;
        error.message = friendlyMessage;
      }

      return Promise.reject(error);
    }
  );
};
